import styled from 'styled-components';
import Link from 'next/link';

import { useTranslation } from '@hooks';
import { Subtitle3, Caption2 } from '@components/styles/Typography';

const ReturnContent = () => {
    const { t, locale } = useTranslation();
    return (
        <Wrapper data-testid="return-content">
            <Subtitle3>{t('howDoIReturn')}</Subtitle3>
            <ContentWrapper>
                <Caption2>{t('returnDescription')}</Caption2>
            </ContentWrapper>
            <Subtitle3>
                {locale === 'en' ? (
                    <Link href="/change-and-return">
                        Click for detailed information
                    </Link>
                ) : (
                    <Link
                        href="/change-and-return"
                        data-testid="return-content-link"
                    >
                        Detaylı bilgi için tıklayınız
                    </Link>
                )}
            </Subtitle3>
        </Wrapper>
    );
};

const Wrapper = styled.div`
    max-width: 400px;

    @media (max-width: 1024px) {
        display: flex;
        flex-direction: column;
        max-width: fit-content;
    }
`;
const ContentWrapper = styled.div`
    padding: 16px 0 20px;

    @media (max-width: 1024px) {
        display: flex;
        flex-direction: column;
        max-width: fit-content;
    }
`;

export default ReturnContent;
